import { api } from "../../axios";

export const actions = {

    // Indicator Itemsss
    GetIndicatorItem(){
        return api.get("Indicator/GetAllIndicatorItems");
    },
    GetIndicatorItemByIndicator(context, data){
        return api.get(`IndicatorItem/indicator/${data}`);
    },
    GetSingleIndicatorItem(context, data){
        return api.get(`IndicatorItem/${data}`);
    },
    UpdateIndicatorItem(context, data){
        return api.put(`IndicatorItem/${data.id}`, data);
    },
    UpdateIndicatorItemSequence(context, data){
        return api.put(`IndicatorItem/Sequence`, data);
    },
    GetParentIndicatorItem(context, data){
        return api.get(`IndicatorItem/Parent/${data.id}/${data.cycle}/${data.campusId}`);
    },
    UpdateParentId(context, data){
        return api.put(`IndicatorItem/Parent/${data.indicatorItemId}/${data.parentId}`);
    },
    DeleteIndicatorItem(context, data){
        return api.delete(`IndicatorItem/${data}`);
    },
    CreateIndicatorItem(context, data){
        return api.post(`IndicatorItem/CreateIndicatorItem`, data);
    },
    AddIndicatorItems(context, data){
        return api.post(`IndicatorItem/Add/Multiple`, data);
    },
    TransferIndicatorItem(context, data){
        return api.post(`IndicatorItem/Update/IndicatorId`, data);
    },
    HideIndicatorItem(context, data){
        return api.put(`IndicatorItem/Hidden/${data.id}/${data.status}`);
    },
    ShowKPIInAdminDashboard(){
        return api.get(`IndicatorItem/AdminDashboard`);
    },
    GetDUsByIndicatorItem(context, data){
        return api.get(`IndicatorItem/DeliveryUnits/${data.id}/${data.cycle}`);
    }
}